import { render, staticRenderFns } from "./ProductStartTemps.vue?vue&type=template&id=12aeae03&scoped=true&"
import script from "./ProductStartTemps.vue?vue&type=script&lang=js&"
export * from "./ProductStartTemps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aeae03",
  null
  
)

export default component.exports